"use client";

import React from "react";
import Breadcrumbs from "@/components/Breadcrumbs";
import NavBar from "@/components/Header/NavBar";
import ToolsComponentMapping from "@/components/ToolsPage/componentMapping";
import { serverReturnType } from "@/components/ToolsPage/interfaces";
import { useSyncToolsData } from "@/components/ToolsPage/useSyncToolsData";
import { getNavBarInfoForCategoryRouting } from "@/helpers";
import routes from "@/helpers/router";
import styles from "./Tool.module.scss";

interface ToolPageProps {
  toolSlug: string;
  pageInfo: serverReturnType;
}

const ToolPage: React.FC<ToolPageProps> = ({ pageInfo, toolSlug }) => {
  const toolsInfo = pageInfo?.toolInfo;
  const userAgent = pageInfo?.ua;

  const navBarList = pageInfo?.navBarList;

  const navBarInfo = getNavBarInfoForCategoryRouting(navBarList?.data);

  const extras = {
    userAgent: userAgent,
    toolSlug: toolSlug,
  };

  useSyncToolsData({ toolsInfo, toolSlug });
  const breadCrumbsArray = [
    {
      label: "Tools",
      url: routes.toolsListing(),
    },
    {
      label: toolsInfo?.toolData?.Name,
      url: routes.tool(toolSlug),
    },
  ];

  const topPanelSections = toolsInfo?.content?.filter((section: any) => section?.Position === "Top");
  const rightPanelSections = toolsInfo?.content?.filter(
    (section: any) => section?.Position !== "Left" && section?.Position !== "Top" && section?.Position !== "Bottom"
  );

  return (
    <>
      <NavBar
        navBarData={{ navBarList: navBarInfo }}
        userOnBoarded={pageInfo?.userOnBoarded}
        userAgent={pageInfo?.ua}
        pathname={routes.tool(toolSlug)}
      />
      <div className={`container breadcrumb ${styles.breadcrumbs}`}>
        <Breadcrumbs options={breadCrumbsArray} />
      </div>

      {userAgent?.isMobile && (
        <>
          {toolsInfo?.content?.map((section: any, index: number) => {
            return (
              <React.Fragment key={`section-${section?.ComponentType}`}>
                <ToolsComponentMapping data={section} extras={extras} />
              </React.Fragment>
            );
          })}
        </>
      )}

      {userAgent?.isDesktop && (
        <>
          <div>
            {topPanelSections?.map((section: any, index: number) => {
              return (
                <React.Fragment key={`section-${section?.ComponentType}`}>
                  <ToolsComponentMapping data={section} extras={extras} />
                </React.Fragment>
              );
            })}
          </div>
          <div className={`${styles.columnsContainer} container`}>
            <div className={styles.leftSection}></div>
            <div className={styles.rightSection}>
              {rightPanelSections?.map((section: any, index: number) => {
                return (
                  <React.Fragment key={`section-${section?.ComponentType}`}>
                    <ToolsComponentMapping data={section} extras={extras} />
                  </React.Fragment>
                );
              })}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ToolPage;
